import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01a56f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-action" }
const _hoisted_2 = {
  key: 0,
  class: "claim-summary"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Price", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Total Minted", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Sold out! ", -1))
const _hoisted_12 = ["data-network", "data-fallback-provider"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sorry, there are no tokens for you to claim.", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "You've claimed all your tokens.", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "spinner"
}
const _hoisted_18 = {
  key: 3,
  class: "campaign-action-transaction"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View tx on Etherscan", -1))
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View Token on OpenSea", -1))

import { ChevronDownIcon, ExternalLinkIcon } from '@heroicons/vue/solid';
import moment from 'moment';
import { onBeforeMount, ref, watch } from 'vue';
import { ClaimConfig, ClaimLimitType } from '@/api/models/claim';
import { Claim721, Claim721Payable, Claim1155, Claim1155Payable } from '@/classes/claimExtensionContract';
import { NETWORK_ID } from '@/common/constants';
import Alert from '@/components/Alert.vue';
import { isExclusiveClaim, isUnlimitedSupply } from '@/lib/claimUtil';
import { AuthState } from '@/store/modules/account.store';
import PlatformLinks from './PlatformLinks.vue';

interface ActionProps {
  error: any;
  status: 'not-started' | 'ended' | 'enabled' | null;
  maxTokenPerWallet: number;
  authState: AuthState;
  isSoldOut: boolean | null | undefined;
  claimConfig: ClaimConfig;
  allowedMintQuantity: number;
  tokenMinted: number | null | undefined;
  networkError: string;
  claimLimitType: ClaimLimitType;
  numberToMint: string;
  tipAmount: number;
  allowMint: boolean;
  claimTokenStatus: 'error' | 'loading' | 'idle' | 'success';
  claim: Claim721 | Claim1155 | Claim1155Payable | Claim721Payable | undefined;
  txLink: string;
  tokenId: number;
  claimToken: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Action',
  props: {
    error: {},
    status: {},
    maxTokenPerWallet: {},
    authState: {},
    isSoldOut: { type: [Boolean, null] },
    claimConfig: {},
    allowedMintQuantity: {},
    tokenMinted: {},
    networkError: {},
    claimLimitType: {},
    numberToMint: {},
    tipAmount: {},
    allowMint: { type: Boolean },
    claimTokenStatus: {},
    claim: {},
    txLink: {},
    tokenId: {},
    claimToken: {}
  },
  emits: ['numberToMintChanged', 'tipAmountChanged'],
  setup(__props: any, { emit }) {

const props = __props;


const _numberToMint = ref('0');
const _tipAmount = ref(0);

onBeforeMount(() => {
  _numberToMint.value = props.numberToMint;
  _tipAmount.value = props.tipAmount;
});



const openTwitterAccount = () => {
  window.open('https://twitter.com/sweetdropnft', '_blank');
};

watch(_numberToMint, (value) => {
  emit('numberToMintChanged', value);
});

watch(_tipAmount, (value) => {
  emit('tipAmountChanged', value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.claim)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("dl", null, [
                _hoisted_3,
                _createElementVNode("dd", null, _toDisplayString((_ctx.claim.cost && parseInt(_ctx.claim.cost) && `${parseInt(_ctx.claim.cost) / 1e18} Ξ`) || 'Free'), 1),
                _hoisted_4,
                _createElementVNode("dd", null, _toDisplayString(_ctx.claim.total) + " " + _toDisplayString(_unref(isUnlimitedSupply)(_ctx.claim) ? '' : `/ ${_ctx.claim.totalMax}`), 1),
                (_ctx.status !== 'not-started' && _ctx.status !== 'ended' && !_ctx.isSoldOut && (typeof _ctx.maxTokenPerWallet !== 'undefined') && _ctx.authState === _unref(AuthState).LOGGED_IN && _ctx.allowedMintQuantity >= 1)
                  ? (_openBlock(), _createElementBlock("dt", _hoisted_5, "Mint Quantity"))
                  : _createCommentVNode("", true),
                (_ctx.status !== 'not-started' && _ctx.status !== 'ended' && !_ctx.isSoldOut && (typeof _ctx.maxTokenPerWallet !== 'undefined') && _ctx.authState === _unref(AuthState).LOGGED_IN && _ctx.allowedMintQuantity >= 1)
                  ? (_openBlock(), _createElementBlock("dd", _hoisted_6, [
                      (_ctx.allowedMintQuantity > 1)
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 0,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_numberToMint).value = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allowedMintQuantity, (index) => {
                              return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(index), 1))
                            }), 128))
                          ], 512)), [
                            [_vModelSelect, _numberToMint.value]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.allowedMintQuantity > 1)
                        ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                            key: 1,
                            class: "chevron"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.allowedMintQuantity === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "1"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!!_ctx.error)
      ? (_openBlock(), _createBlock(Alert, {
          key: 0,
          type: "error"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: _ctx.error.error
            }, null, 8, _hoisted_8)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.status === 'not-started')
      ? (_openBlock(), _createBlock(Alert, {
          key: 1,
          type: "info"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, "This claim hasn't started yet. Come back " + _toDisplayString(_unref(moment)(_ctx.claimConfig?.startDate).calendar()) + ".", 1)
          ]),
          _: 1
        }))
      : (_ctx.status === 'ended')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(Alert, { type: "info" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, " This claim ended " + _toDisplayString(_unref(moment)(_ctx.claimConfig?.endDate).fromNow()) + ". ", 1)
              ]),
              _: 1
            }),
            _createVNode(PlatformLinks, {
              claimConfig: _ctx.claimConfig,
              claim: _ctx.claim,
              label: 'Find tokens on secondary'
            }, null, 8, ["claimConfig", "claim"])
          ]))
        : (_ctx.isSoldOut)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(Alert, { type: "info" }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(PlatformLinks, {
                claimConfig: _ctx.claimConfig,
                claim: _ctx.claim,
                label: 'Find tokens on secondary'
              }, null, 8, ["claimConfig", "claim"])
            ]))
          : ((typeof _ctx.maxTokenPerWallet !== 'undefined'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                ((_ctx.authState !== _unref(AuthState).LOGGED_IN) && !_ctx.networkError.length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      "data-widget": "m-connect",
                      "data-network": _unref(NETWORK_ID),
                      "data-wallet-connect-project-id": "b5fbaf83b34ce437fc00af569e9591b3",
                      "data-fallback-provider": _ctx.claimConfig?.fallbackProvider && _ctx.claimConfig?.fallbackProvider.length ? _ctx.claimConfig?.fallbackProvider : undefined,
                      "data-multi": "true"
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true),
                (_ctx.authState === _unref(AuthState).LOGGED_IN)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.allowedMintQuantity == 0 && !_ctx.tokenMinted)
                        ? (_openBlock(), _createBlock(Alert, {
                            key: 0,
                            type: "info"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.allowedMintQuantity == 0 && _ctx.tokenMinted && _ctx.tokenMinted > 0)
                        ? (_openBlock(), _createBlock(Alert, {
                            key: 1,
                            type: "info"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.allowedMintQuantity >= 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_ctx.tokenMinted === 0)
                              ? (_openBlock(), _createBlock(Alert, {
                                  key: 0,
                                  type: "info"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.claimLimitType !== 'open'
                  ? `You can mint up to ${_ctx.allowedMintQuantity} tokens`
                  : `You can mint up to ${_ctx.allowedMintQuantity} tokens per transaction (unlimited mint)`), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.claimLimitType !== 'open')
                                ? (_openBlock(), _createBlock(Alert, {
                                    key: 1,
                                    type: "info"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(`${_ctx.tokenMinted ?? 0} of ${_ctx.allowedMintQuantity} tokens claimed`), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.claimToken && _ctx.claimToken(...args))),
                        disabled: !_ctx.allowMint || _ctx.networkError.length,
                        class: _normalizeClass([{enabled: (_ctx.allowMint && !_ctx.networkError.length)}, "campaign-action-button"])
                      }, [
                        (_ctx.claimTokenStatus !== 'loading')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(`
                Mint
              `)))
                          : _createCommentVNode("", true),
                        (_ctx.claimTokenStatus == 'loading')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_15), [
                        [_vShow, _ctx.allowedMintQuantity != 0]
                      ]),
                      ( _ctx.txLink.length > 0 || _ctx.tokenId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            (_ctx.txLink.length > 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: `https://etherscan.io/tx/${_ctx.txLink}`,
                                  target: "_blank"
                                }, [
                                  _hoisted_20,
                                  _createVNode(_unref(ExternalLinkIcon), { class: "link-icon" })
                                ], 8, _hoisted_19))
                              : _createCommentVNode("", true),
                            (_ctx.tokenId)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  href: `https://opensea.io/assets/${_ctx.claimConfig?.creatorContractAddress}/${_ctx.tokenId}`,
                                  target: "_blank"
                                }, [
                                  _hoisted_22,
                                  _createVNode(_unref(ExternalLinkIcon), { class: "link-icon" })
                                ], 8, _hoisted_21))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
  ]))
}
}

})